import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { deleteProducto } from '../../../services/productos/productos';
import ImgThumb from '../../ImgThumb';

const useProductosTable = ({ onDelete }: { onDelete: () => void }) => {

    const navigate = useNavigate()

    const handleDelete = async (id: string) => {
        if (!window.confirm('¿Estás seguro de que deseas eliminar este producto?')) return
        try {
            await deleteProducto(id)
            onDelete()
        } catch (e) {
            alert('Error al eliminar el producto')
            console.error(e)
        }
    }

    const columns: GridColDef[] = [
       
        {
            field: 'nombre',
            headerName: 'Titulo',
            width: 200
        },
        {
            field: 'sku',
            headerName: 'SKU',
            width: 200
        },
        {
            field: 'categoria',
            headerName: 'Categoria',
            width: 200,
            //renderCell: (e) => <ImgThumb src={e.value} />
        },
        {
            field: 'visitas',
            headerName: 'Visitas',
            width: 200,
            //renderCell: (e) => <ImgThumb src={e.value} />
        },
        {
            field: 'descargable',
            headerName: 'Descargable',
            width: 200,
        },
        {
            field: 'imagen_principal',
            headerName: 'Imagen principal',
            width: 200,
            renderCell: (e) => <ImgThumb src={e.row.imagen_principal} />
        },
        {
            field: 'destacado',
            headerName: 'Destacado',
            width: 120,
            renderCell: (e) => e.value === '1' || e.value === 1 ? 'Sí' : 'No'
        },
        
        {
            field: 'acciones',
            headerName: 'Acciones',
            width: 200,
            renderCell: (e) => {
                return <div style={{
                    display: 'flex',
                    gap: 4,
                }}>
                    <Button variant="contained" style={{ backgroundColor: 'transparent'}} onClick={() => {
                        navigate(`/producto/${e.id}`)
                    }}>
                        <img src={'./assets/img/editar.png'} alt="Button Image" style={{ width: '20px', height: '20px' }} />
                    </Button>
                    <Button variant="contained" color="error" onClick={() => handleDelete(String(e.id))}>
                        <DeleteIcon />
                    </Button>
                </div>
            }
        },
    ];

    return {
        columns
    }

}

export default useProductosTable